import { render, staticRenderFns } from "./QueryViolationModal.vue?vue&type=template&id=06cf1f62&"
import script from "./QueryViolationModal.vue?vue&type=script&lang=js&"
export * from "./QueryViolationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports